<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Invoice Detail",
    };
  },
  computed: {
    ...mapGetters("payments", [
      "PatientInvoiceDetails",
      "PersonalInvoiceStatus",
      "PaymentModes",
    ]),
    ...mapGetters("auth", ["user_permissions"]),
  },
  methods: {
    ...mapActions({
      FetchPatientInvoice: "payments/fetchPatientInvoice",
      FetchPaymentModes: "payments/fetchPaymentModes",
    }),
  },
  created() {
    this.FetchPatientInvoice(this.$route.params.invoice_id);
    this.FetchPaymentModes();
  },
};
</script>
<style scoped>
tr, td {
  padding-top: 2px;
  padding-bottom: 2px;
}
.print {
  font-family: "Lucida Console", "Courier New", monospace;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              v-if="user_permissions.view_invoice"
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Invoice</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
        <div class="bg-white p-2 print">
          <div class="invoice-title">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <b-spinner
                  v-if="PersonalInvoiceStatus"
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <img
                  v-else
                  :src="
                    PatientInvoiceDetails.clinicLogo
                      ? PatientInvoiceDetails.clinicLogo
                      : '---'
                  "
                  alt="logo"
                  height="115px"
                />
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <p
                  style="
                    text-transform: uppercase;
                    text-align: right;
                    font-size: 20px;
                    font-weight: bold;
                  "
                >
                  {{
                    PatientInvoiceDetails.clinicName
                      ? PatientInvoiceDetails.clinicName
                      : "-----"
                  }}
                </p>
                <table align="right" width="100%" style="font-size: 12px">
                  <tr align="right">
                    <td
                      v-html="
                        PatientInvoiceDetails.clinicAddress
                          ? PatientInvoiceDetails.clinicAddress
                          : '---'
                      "
                    ></td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      {{
                        PatientInvoiceDetails.clinicPhone
                          ? PatientInvoiceDetails.clinicPhone
                          : "---"
                      }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Email:</strong>
                      {{
                        PatientInvoiceDetails.clinicEmail
                          ? PatientInvoiceDetails.clinicEmail
                          : "---"
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-12">
              <table width="100%">
                <tr>
                  <td width="50%">
                    <p style="margin: 5px">
                      Deliver to:
                      <b>{{
                        PatientInvoiceDetails.payer ? PatientInvoiceDetails.payer : "---"
                      }}</b>
                    </p>
                    <p style="margin: 5px">
                      Address:
                      <b>{{
                        PatientInvoiceDetails.address
                          ? PatientInvoiceDetails.address
                          : "---"
                      }}</b>
                    </p>
                    <p style="margin: 5px">
                      Contact:
                      <b>+{{
                        PatientInvoiceDetails.contact
                          ? PatientInvoiceDetails.contact
                          : "---"
                      }}</b>
                    </p>
                  </td>
                  <td style="text-align: right">
                    <p style="margin: 5px">
                      Date:
                      <b>{{ new Date().toLocaleString() }}</b>
                    </p>
                    <p style="margin: 5px">
                      Invoice No.:
                      <strong
                        >#{{
                          PatientInvoiceDetails.code ? PatientInvoiceDetails.code : "---"
                        }}</strong
                      >
                    </p>
                    <p style="margin: 5px">
                      Due Date:
                      <strong
                        >{{
                          PatientInvoiceDetails.due_date
                            ? PatientInvoiceDetails.due_date
                            : "---"
                        }}
                      </strong>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <h3 class="font-size-16">SERVICES</h3>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>QTY</th>
                       <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(serv, index) in PatientInvoiceDetails.records"
                      :key="index"
                    >
                      <td>{{ serv.service }}</td>
                      <td>{{ serv.quantity }}</td>
                       <td>{{ serv.serv_date }}</td>
                      <td>{{ serv.cost }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <h3 class="font-size-16">PAYMENT DETAILS</h3>
              </div>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Total</th>
                      <th>Discount</th>
                      <th>Paid</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                          PatientInvoiceDetails.total
                            ? PatientInvoiceDetails.total
                            : "---"
                        }}
                      </td>
                      <td>
                        {{
                          PatientInvoiceDetails.discount
                            ? PatientInvoiceDetails.discount
                            : "---"
                        }}
                      </td>
                      <td>
                        {{
                          PatientInvoiceDetails.paid_sofar
                            ? PatientInvoiceDetails.paid_sofar
                            : "---"
                        }}
                      </td>
                      <td>
                        {{
                          PatientInvoiceDetails.balance
                            ? PatientInvoiceDetails.balance
                            : "---"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="p-2">
                <h3 class="font-size-16">PAYMENT MODES</h3>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Provider</th>
                      <th>Account Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mode, index) in PaymentModes" :key="index">
                      <td>{{ mode.modeName }}</td>
                      <td>{{ mode.provider }}</td>
                      <td>{{ mode.modeNumber ? mode.modeNumber : "--" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table width="100%">
              <tr>
                <center>
                  <p>Signature ..........................................</p>
                </center>
              </tr>
              <tr>
                <td>
                  <center>
                    Thank you for trusting
                    <strong>{{
                      PatientInvoiceDetails.clinicName
                        ? PatientInvoiceDetails.clinicName
                        : "---"
                    }}</strong>
                  </center>
                </td>
              </tr>
              <tr>
                <td>
                  <center>
                    For more inquiries call
                    <strong
                      >+{{
                        PatientInvoiceDetails.clinicPhone
                          ? PatientInvoiceDetails.clinicPhone
                          : "---"
                      }}</strong
                    >
                  </center>
                </td>
              </tr>

              <tr>
                <center>
                  <p>
                    Invoice Printed by
                    {{
                      PatientInvoiceDetails.printuser
                        ? PatientInvoiceDetails.printuser
                        : "---"
                    }}
                    via Clinic Plus Hospital Software
                  </p>
                </center>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
